import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { NeedContextProvider } from './NeedContext';
import ViewNeed from './ViewNeed';
import EditNeed from './EditNeed';
import ManageFiles from './ManageFiles';

const NeedsPage: React.FC = () => (
    <NeedContextProvider>
      <Switch>
        <Route path="/needs/new" component={EditNeed} />
        <Route path="/needs/:needId/edit" component={EditNeed} />
        <Route path="/needs/:needId/view" component={ViewNeed} />
        <Route path="/needs/:needId/upload" component={ManageFiles} />
      </Switch>
    </NeedContextProvider>
  );

export default NeedsPage;
